import React from 'react';
import styled from 'styled-components';
import Navigation from '../components/layout/Navigation';
import MetricsSection from '../components/sections/MetricsSection';

const Story: React.FC = () => {
  return (
    <StoryContainer>
      <Navigation />
      <StoryContent>
        <MetricsSection />
      </StoryContent>
    </StoryContainer>
  );
};

const StoryContainer = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
`;

const StoryContent = styled.div`
  padding-top: 6rem;
`;

export default Story; 